export const TOTAL_COLUMN = 'Totalt';
export const CUSTOMER_COLUMN = 'Kund';
export const CATEGORY_COLUMN = 'Kategori';
export const MACHINE_ID_COLUMN = 'machineID';
export const NUMBER_COLUMN = 'Number';
export const SIE_EXPORT_COLUMN = 'SIE-Export';
export const INVOICE_COLUMN = 'InvoiceNumber';
export const Z_REPORT_NUMBER = 'ZReportNumber';
export const CREATED_BY_COLUMN = 'Skapad av';
export const CREATED_BY_COLUMN_2 = 'CreatedBy';
export const AMOUNT_OF_SOLD_GOODS_COLUMN = 'Mängd sålda varor';
export const CURRENT_BALANCE_STOCK = 'Befintligt lagersaldo';
export const NUMBER_OF_SOLD_GOODS_COLUMN = 'Antal sålda varor';
export const AMOUNT_OF_RETURNED_ITEMS = 'Mängd returnerade varor';
export const NUMBER_OF_RETURNED_ITEMS = 'Antal returnerade varor';
export const NET_NUMBER_OF_SOLD_GOODS = 'Nettoantal varor';
export const SALES_VAT_PROPERTY = 'FörsäljningCoMmA moms';
export const SALES_INCL_VAT = 'Försäljning inkl. moms';
export const SALES_EXCL_VAT = 'Försäljning exkl. moms';
export const NET_QUANTITY_VALUE = 'Nettomängd varor';
export const RETURNS_INCL_VAT = 'Returer inkl. moms';
export const RETURNS_EXCL_VAT = 'Returer exkl. moms';
export const RETURNS_SUM_VAT = 'ReturerCoMmA moms';
export const NET_SALES_INCL_VAT = 'Nettoförsäljning inkl. moms';
export const NET_SALES_EXCL_VAT = 'Nettoförsäljning exkl. moms';
export const NET_SALES_SUM_VAT = 'NettoförsäljningCoMmA moms';
export const AMOUNT_OF_TRANSACTIONS = '**TOTAL**|ANTAL KVITTON';
export const SOLD_GIFT_CARDS = 'PRESENTKORT|BELOPP';
export const OVERVIEW_TOTAL = '**TOTAL**|BELOPP';
export const PURCHASE_PRICE_OF_SOLD_GOODS_EXCL_VAT = 'Inköpspris sålda varorCoMmA exkl. moms';
export const PURCHASE_PRICE_OF_RETURNED_GOODS_EXCL_VAT = 'Inköpspris returnerade varorCoMmA exkl. moms';
export const NET_PURCHASE_PRICE_OF_SOLD_GOODS_EXCL_VAT = 'Inköpspris nettoCoMmA exkl. moms';
export const TOTAL_PROFIT_EXCL_VAT = 'Total vinstCoMmA exkl. moms';
export const TOTAL_PROFIT = 'Total vinstCoMmA %';
export const PAYMENT_TYPE = 'Betalningstyp';
export const PAYMENT_TYPE_CASH = 'Kontant (betalning)';
export const PAYMENT_TYPE_CARD = 'Kort (betalning)';
export const PAYMENT_TYPE_SWISH = 'Swish (betalning)';
export const CASH_REGISTER_COLUMN = 'CashRegister';
export const ID_COLUMN = 'Id';
export const TRANSACTION_TYPE = 'Transaktionstyp';
export const SUM_COLUMN = 'Summa';
export const DATE_TIME_COLUMN = 'DateTime';
export const DATE_COLUMN = 'Datum';
export const DATE_COLUMN_2 = 'Datum & kl.';
export const DATE_COLUMN_3 = 'Datum & tid';
export const EMPLOYEE_ID_COLUMN = 'Anställd#';
export const EMPLOYEE_COLUMN = 'Anställd';
export const EMPLOYEE_NAME_COLUMN = 'EnteredByEmployeeName';
export const PERSONAL_NUMBER_COLUMN = 'Personalnr.';
export const NAME_COLUMN = 'Namn';
export const TOTAL_PRICE_COLUMN = 'Totalt pris';
export const QUANTITY_COLUMN = 'Antal';
export const TOTAL_QUANTITY_COLUMN = 'Totalt antal';
export const CAUSE_COLUMN = 'Orsak:';
export const ITEM_COLUMN = 'Vara';
export const ARTICLE_NUMBER = 'Artikelnr.';
export const ARTICLE_NUMBER_2 = 'Artikelnummer';
export const DESCRIPTION_COLUMN = 'Beskrivning';
export const PERSONAL_NAME_COLUMN = 'Personalnamn';
export const TYPE_COLUMN = 'Type';
export const TYPE_COLUMN_2 = 'Typ';
export const FILE_COLUMN = 'File';
export const PAYMENT_COLUMN = 'Payment';
export const PAYMENT_IDENTIFIER = 'Terminal';
export const RECEIPTS_QUANTITY = 'Antal kvitton';
export const RETURNS_QUANTITY = 'Antal returer';
export const PURCHASE_PRICE_EXCL_VAT_PCS = 'Inköpspris exkl. moms/st.';
export const TOTAL_PURCHASE_PRICE_EXCL_VAT = 'Totalt inköpspris exkl. moms';
export const GIFT_CARDS_QUANTITY = 'Antal presentkort';
export const ACTIVE_GIFT_CARDS_BALANCE = 'Saldo för aktiva presentkort';
export const INACTIVE_GIFT_CARDS_BALANCE = 'Saldo för inaktiva presentkort';
export const PRODUCT_COLUMN = 'Produkt';
export const CAMPAIGN_COLUMN = 'Kampanj';
export const SUPPLIER_COLUMN = 'Leverantör';
export const TOTAL_PRICE_INCL_VAT_COLUMN = 'Totalt pris inkl. moms';
export const TOTAL_AMOUNT_WITH_VAT = 'TotalAmountIncludingVat';
